import React from 'react';
import SummaryCard from './SummaryCard';

function MetricsToTrack({ metrics, note }) {
    return (
        <SummaryCard title="Metrics to Track">
            <div className="overflow-x-auto">
                <table className="w-full">
                    <thead>
                        <tr className="border-b border-gray-200">
                            <th className="content-text text-left py-3 font-medium text-gray-800">Metric</th>
                            <th className="content-text text-left py-3 font-medium text-gray-800">
                                Current <span className="font-normal text-gray-500">(Target)</span>
                            </th>
                            <th className="content-text text-left py-3 font-medium text-gray-800">Review</th>
                        </tr>
                    </thead>
                    <tbody>
                        {metrics.map((row, idx) => (
                            <tr key={row.metric} className={idx < metrics.length - 1 ? 'border-b border-gray-100' : ''}>
                                <td className="content-text py-4 font-medium text-gray-900">
                                    {row.metric}
                                </td>
                                <td className="content-text py-4 text-gray-700">
                                    {row.current}
                                    {row.target && (
                                        <span className="text-gray-500 ml-1">({row.target})</span>
                                    )}
                                </td>
                                <td className="content-text py-4 text-gray-600">
                                    {row.review}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Bottom note */}
            <div className="mt-6 p-4 rounded-lg bg-purple-50 border border-purple-100">
                <div className="flex items-center gap-2">
                    <span className="text-pink-500 text-lg">❤</span>
                    <div>
                        <p className="content-text text-gray-700 font-medium mb-0">
                            Think of these reviews as a
                        </p>
                        <p className="content-text text-gray-800 font-medium">
                            Regular Financial Health check up!!
                        </p>
                    </div>
                </div>
            </div>
        </SummaryCard>
    );
}

export default MetricsToTrack;